const { getOffsetTop } = window.BAO.Utils

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveCarousel()
  }

  moveCarousel () {
    if (!window.BAO.MediaBreakpoints.isMd) return

    const slidesEl = this.els.slides.element

    const animationDuration = 0

    const cardSize = window.BAO.MediaBreakpoints.isXxlg
      ? parseFloat(this.dataset.xxlgTotal)
      : window.BAO.MediaBreakpoints.isLg
        ? parseFloat(this.dataset.lgTotal)
        : parseFloat(this.dataset.mdTotal)

    const amountToMoveX = cardSize - 150

    const elementHeight = this.offsetHeight

    const elementStartPoint = getOffsetTop(this)
    const elementEndPoint =
      getOffsetTop(this) + elementHeight - window.innerHeight

    if (this.lastKnownY <= elementStartPoint) {
      setTimeout(() => {
        slidesEl.style.transform = `translate3d(0vw, 0px, 0px)`
      }, animationDuration)

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      setTimeout(() => {
        slidesEl.style.transform = `translate3d(-${amountToMoveX}vw, 0px, 0px)`
      }, animationDuration)

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const transformAmountX = amountToMoveX * scrollYAsAPercentageOfJourney

    setTimeout(() => {
      slidesEl.style.transform = `translate3d(-${transformAmountX}vw, 0px, 0px)`
    }, animationDuration)
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
